import React, {useEffect} from "react";
import * as StorageService from "../services/StorageService.js";
import {LOCALSTORAGE_ITEMS, ORDER_PLACE} from "../util/Constants";
import {PATH} from "../routes/routes";
import {clearStorageItems, handleAppVersionUpdate} from "../util/common";
import {useLocation, useNavigate} from "react-router";
import {useParams} from "react-router-dom";
import * as ClientConfig from "../config/ClientConfig";


function TableQrScan(props) {
    const navigateTo = useNavigate();
    const {shopName, userTable} = useParams();
    const decodedUserTable = decodeURIComponent(userTable);

    const useQuery = () => new URLSearchParams(useLocation().search);
    const query = useQuery();
    const refUrl = query.get('refUrl');
    const returningUrl = query.get('returningUrl');
    const domain = ClientConfig.URL_RESOURCE_SERVER;
    useEffect(() => {
        continueToMenu();
    }, []);

    const continueToMenu = () => {
        handleAppVersionUpdate();
        clearStorageItems();
        StorageService.removeItem(LOCALSTORAGE_ITEMS.CURRENT_CART);
        StorageService.setItem(LOCALSTORAGE_ITEMS.SHOP_NAME, shopName);
        StorageService.setItem(LOCALSTORAGE_ITEMS.USER_TABLE, decodedUserTable);
        StorageService.setItem(LOCALSTORAGE_ITEMS.ORDER_PLACE, ORDER_PLACE.TABLE);
        StorageService.setItem(LOCALSTORAGE_ITEMS.HAS_BACK_BUTTON, "false");
        const url =  refUrl
            ? `${PATH.MAIN}?refUrl=${encodeURIComponent(refUrl)}${returningUrl ? `&returningUrl=${encodeURIComponent(returningUrl)}` : ''}`
            : returningUrl
                ? `${PATH.MAIN}?returningUrl=${encodeURIComponent(returningUrl)}`
                : PATH.MAIN

        navigateTo(url);
    }

    return (
        <div className="redirect-msg">
            Redirecting to Zoniz Ordering app...
        </div>


    );
}

export default TableQrScan;
